import React, { useState, useRef, useEffect } from "react";
import {
  FaBoxOpen,
  FaChartBar,
  FaCog,
  FaUserCircle,
  FaClipboardList,
  FaCrown,
  FaTruck,
  FaBars,
  FaTimes,
} from "react-icons/fa";
import { MdDashboard } from "react-icons/md";
import "../../../Styles/Seller/Header.css";
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import nexoraimg from "../../../assests/elumiya.png";
import { useSellerAuth } from "../../../Common/SellerAuthContext";
import SellerNotificationBell from "../NotificationBell";

function Header() {
  const [open, setOpen] = useState(false);
  const [navOpen, setNavOpen] = useState(false);
  const dropdownRef = useRef(null);
  const location = useLocation();
  const navigation = useNavigate();
  const { logoutSeller, seller } = useSellerAuth();

  const handleLogout = () => {
    logoutSeller();
    navigation("/sellerhome", { replace: true });
  };

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  useEffect(() => {
    if (!navOpen) return undefined;
    const onKeyDown = (event) => { if (event.key === "Escape") setNavOpen(false); };
    document.addEventListener("keydown", onKeyDown);
    return () => document.removeEventListener("keydown", onKeyDown);
  }, [navOpen]);

  const isActive = (path) => {
    return (
      location.pathname === path || location.pathname.startsWith(`${path}/`)
    );
  };

  return (
    <header className="seller-header">
      <button type="button" className="seller-mobile-menu-btn" onClick={() => setNavOpen((value) => !value)} aria-label={navOpen ? "Close seller menu" : "Open seller menu"} aria-expanded={navOpen} aria-controls="seller-main-nav">{navOpen ? <FaTimes /> : <FaBars />}</button>
      <div
        className="seller-logo"
        style={{ cursor: "pointer" }}
        onClick={() => {
          navigation("/dashboard");
        }}
      >
        <img src={nexoraimg} alt="Logo" style={{ width: "110px" }} />
        {/* <span>
          <strong>Elumia</strong>&nbsp; Med Store
        </span> */}
      </div>

      <nav id="seller-main-nav" className={`seller-nav ${navOpen ? "is-open" : ""}`} aria-label="Seller navigation" onClick={(event) => { if (event.target.closest("a")) setNavOpen(false); }}>
        <a href="/dashboard" className={isActive("/dashboard") ? "active" : ""}>
          <MdDashboard /> Dashboard
        </a>
        <a
          href="/seller/product"
          className={isActive("/seller/product") ? "active" : ""}
        >
          <FaBoxOpen /> Stock Management
        </a>
        <a
          href="/seller/order"
          className={isActive("/seller/order") ? "active" : ""}
        >
          <FaClipboardList /> Orders
        </a>
        <a
          href="/seller/analytics"
          className={isActive("/seller/analytics") ? "active" : ""}
        >
          <FaChartBar /> Analytics
        </a>
        <a
          href="/seller/tracking"
          className={isActive("/seller/tracking") ? "active" : ""}
        >
          <FaTruck /> Tracking
        </a>
        {/* <a href="#marketing" className={isActive("#marketing") ? "active" : ""}>
          <FaGift /> Marketing
        </a> */}
        <a
          href="/sellersetting"
          className={isActive("#settings") ? "active" : ""}
        >
          <FaCog /> Settings
        </a>
        <a href="/seller/notifications" className="seller-mobile-notifications">Notifications</a>
      </nav>
      <div className="seller-right" ref={dropdownRef}>
        <div className="seller-welcome">
          <span style={{ color: "white" }} className="profile-name">
            Welcome back, {seller?.username || "Seller"}
          </span>
          <FaCrown style={{ color: "#FFD700", fontSize: "18px" }} />
        </div>
        <SellerNotificationBell />
        {/* <img
          src="https://i.pravatar.cc/40"
          alt="Profile"
          className="profile-img"
          onClick={() => setOpen(!open)}
        /> */}
        <div className="seller-profile" onClick={() => setOpen(!open)}>
          <div className="profile-icon-container">
            <FaUserCircle className="profile-icon" />
          </div>
        </div>
        {/* Dropdown */}
        {open && (
          <div className="profile-dropdown">
            <button onClick={handleLogout}>Logout</button>
          </div>
        )}
      </div>
    </header>
  );
}

export default Header;
